import { Box, styled } from '@mui/material';

export const ButtonsBlock = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: '10px 30px',
  gridTemplateColumns: 'none',
  [theme.breakpoints.down(768)]: {
    gridTemplateColumns: '1fr',
  },
}));

export const buttonLinkStyles = () => ({
  color: '#00a800',
  fontSize: '1.125rem',
  minHeight: '70px',
  display: 'inline-flex',
  alignItems: 'center',
  marginLeft: 'auto',
  '*, svg': {
    color: 'inherit',
    fontSize: 'inherit',
    verticalAlign: 'middle',
  },
  '&:hover': {
    color: 'var(--black)',
  },
});

export const buttonOrangeStyles = () => ({
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
  justifyContent: 'center',
  color: '#fff',
  background: 'var(--orange)',
  border: '1px solid var(--orange);',
  height: '70px',
  padding: '0 25px',
  transition: 'all .2s ease-in-out',
  margin: 'auto',
  fontSize: '1.125rem',
  '*': {
    color: 'inherit',
  },
  '&:hover': {
    color: 'var(--orange)',
    border: '1px solid var(--orange)',
    background: '#fff'
  },
});

export const buttonExampleStyles = () => ({
  display: 'inline-flex',
  alignItems: 'center',
  color: 'var(--black)',
  background: 'var(--white)',
  border: '1px solid var(--border-grey)',
  height: '70px',
  padding: '0 25px',
  transition: 'all .2s ease-in-out',
  fontSize: '1.125rem',
  cursor: 'pointer',
  '*': {
    color: 'inherit',
  },
  '&:hover': {
    color: 'var(--black)',
  },
});
